module.exports = __webpack_public_path__ + "assets/img/PEDIDOSENCURSO.b18e24d5.svg";